app.service('productStateSection', function (store, productStateOutletModal, front) {

	let $stateButtons;

	function init(props) {
		$stateButtons = props.$el.find('.state-button');
		setActiveButton();
		setEvents();
	}

	function setActiveButton() {
		let $activeStateButton = $stateButtons.filter(`[data-state=${store.data.isOutlet ? 'outlet' : 'new'}]`);
		$activeStateButton.addClass('is-active');
		$stateButtons.not($activeStateButton).removeClass('is-active');
	}

	function setEvents() {
		$stateButtons.parent()
			.on('click', '.js-new-state', handleNewStateButtonClick)
			.on('click', '.js-select-outlet-category', handleSelectOutletCategoryClick);
	}

	function handleNewStateButtonClick(e) {
		e.preventDefault();

		if ($(this).hasClass('is-active')) return;

		store.dispatch('setNewState');

		UA.pageInteraction('CTA', 'Opcje zakupowe - Nowy');
		UA.interaction('KP_Crossell', 'Nowy_produkt', 'Kliknięcie');
		handleTabStateAnalytic($(this).data('state')==='new');
	}

	function handleSelectOutletCategoryClick(e) {
		e.preventDefault();
		productStateOutletModal.show();
		UA.interaction('KP_Crossell', 'Outlet', 'Kliknięcie');
		handleTabStateAnalytic($(this).data('state')==='new');
	}

	function handleTabStateAnalytic(state) {
		const tabType = state ? 'Nowy' : 'Outlet';
		UA.pageInteraction('CTA', 'Zakładka - ' + tabType);
		app.logEvent({
			'id': 'switch-product-tab',
			'f03': front.page(), 
			'f04': 'Zakładka - ' + tabType
		});
	}

	return {
		init
	};
});